import React, { useEffect, useState } from 'react';
import Navbar from '../../../components/navbar/Navbar';
import Footer from '../../../components/footer/Footer';
import { useParams, Link } from 'react-router-dom';
import DOMPurify from 'dompurify';
import './Article.css';

const Article = () => {
  const { id } = useParams();
  const [article, setArticle] = useState(null);

  useEffect(() => {
    fetch('/news-json/news-core.json') // Ensure the path is correct
      .then(response => {
        if (!response.ok) {
          throw new Error('Network response was not ok');
        }
        return response.json();
      })
      .then(data => {
        const articleData = data[id];
        setArticle(articleData);
      })
      .catch(error => console.error('Error fetching article:', error));
  }, [id]);

  if (!article) {
    return <div>Loading...</div>;
  }

  return (
    <>
      <Navbar />
      <div className="article-container">
        <Link to="/" className="close-button" title="Back to Home">×</Link>
        <h2 className="article-heading">{DOMPurify.sanitize(article.header)}</h2>
        <p className="article-date">{DOMPurify.sanitize(article.date)}</p>
        <img src={DOMPurify.sanitize(article.image)} alt="Article" className="article-image" />
        <div className="article-content">
          <p>{DOMPurify.sanitize(article.content)}</p>
        </div>
        <div className="article-author">
          <p>Written by: {DOMPurify.sanitize(article.author)}</p>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default Article;